<template>
  <v-dialog
    v-model="dialog"
    transition="slide-y-transition"
    width="600"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-bind="attrs"
        v-on="on"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card class="grey lighten-5">
      <v-card-title class="grey lighten-4">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = !dialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form">
          <v-autocomplete
            label="Nome do Ponte, Viaduto, etc"
            v-model="params.nome"
            :items="options.nome"
            item-text="nome" item-value="id"
            clearable
            multiple
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="reset()">Limpar</v-btn>
        <v-btn @click="addLayer()" color="primary">Pesquisar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//import axios from 'axios'
import * as L from 'leaflet'
import { getBounds } from '@/domain/library'

import { denominacaoPonte, proxy } from '@/api/vue-exemplo'

export default {
  name: 'DenominacaoPontes',
  data: () => ({
    name: 'der:denominacao_ponte',
    title: 'Denominação de Pontes, Viadutos, etc',
    dialog: false,
    params: {
      nome: ''
    },
    options: {
      nome: []
    },
    template: [
      { text: 'Tipo', value: 'tipo' },
      { text: 'Nome', value: 'nome' },
      { text: 'Local', value: 'local' },
      { text: 'Assunto', value: 'assunto' },
      //{ text: 'inform.', value: 'inform.' },
      { text: 'Lei', value: 'lei' },
      //{ text: 'verif', value: 'verif' },
      { text: 'Link', value: 'link' }
    ]
  }),
  mounted () {
    this.getNome()
  },
  methods: {
    reset () {
      this.$refs.form.reset()

      this.removeLayer()
      this.$root.$emit('fitBounds', getBounds())

      this.dialog = false
    },
    addLayer () {
      if (this.geojson) {
        this.$root.$emit('removeGeoJson', this.geojson)
      }

      var params = {
        service: 'wfs',
        version: '2.0.0',
        outputFormat: 'application/json',
        exceptions: 'application/json',
        request: 'GetFeature',
        typeNames: this.name,
        srsName: 'EPSG:4674'
      }

      if (this.params.nome.length != 0) {
        params.cql_filter = "id IN (" + this.params.nome.map(a => "'" + a + "'").toString() + ")"
      }

      proxy.geoProxy({
        url: process.env.VUE_APP_GEOSERVER + L.Util.getParamString(params)
      })
        .then(response => {
          this.geojson = L.geoJson(response.data, {
            onEachFeature: (feature, layer) => {
              var popupContent = "<table>"
              for(var header of this.template) {
                popupContent += "<tr><th>" + header.text + ":</th>"
                if(header.value == "link") {
                  popupContent += "<td><a target='blank' href=" + feature.properties[header.value] + ">Abrir</a></td></tr>"
                } else {
                  popupContent += "<td>" + feature.properties[header.value] + "</td></tr>"
                }
              }
              popupContent += "</table>"
              layer.bindPopup(popupContent)
            },
            pointToLayer: function (feature, latlng) {
              return L.circleMarker(latlng, {
                radius: 6
              })
            }
          })

          this.$root.$emit('addGeoJson', this.geojson)
        })
        .catch(error => {
          console.log(error)
        })

      this.dialog = false
    },
    removeLayer () {
      if (this.geojson) {
        this.$root.$emit('removeGeoJson', this.geojson)
      }
    },
    getNome () {
      denominacaoPonte.getNome()
        .then(response => {
          this.options.nome = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
